import { ReactNode, startTransition, useEffect, useState } from "react"
import { useHydrated } from "@/hooks/use-hydrated"

export function ClientRender({
  loading,
  children,
}: {
  loading?: ReactNode
  children: ReactNode
}) {
  const [isMounted, setIsMounted] = useState(false)
  // Hydrated from server HTML, the children are a second render of the page
  // right after hydration; as a transition React renders them in slices instead
  // of one long task. Mounted after hydration (a soft navigation), they still
  // render before the first paint.
  const hydrated = useHydrated()
  const [mountAsTransition] = useState(!hydrated)

  useEffect(() => {
    if (mountAsTransition) {
      startTransition(() => setIsMounted(true))
    } else {
      setIsMounted(true)
    }
  }, [mountAsTransition])

  if (!isMounted) {
    if (loading) {
      return <>{loading}</>
    }
    return null
  }

  return <>{children}</>
}
